import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./Texts.da.resx"
import { R as _en } from "./Texts.en.resx"
import { R as _no } from "./Texts.no.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"CallIssueCamera": string,
	"CallIssueMicrophone": string,
	"CallIssueNetwork": string,
	"CallIssueReconnectQuestion": string,
	"CallIssueTitle": string,
	"CallQualityFeedback_Bad": string,
	"CallQualityFeedback_Ok": string,
	"CallQualityFeedback_Title": string,
	"CallReJoinButton": string,
	"Camera": string,
	"CameraOffTooltip": string,
	"CameraOnTooltip": string,
	"Close": string,
	"Connected": string,
	"Connecting": string,
	"DeviceSelectionDropdownCameraPlaceholderChoose": string,
	"DeviceSelectionDropdownCameraPlaceholderEmpty": string,
	"DeviceSelectionDropdownMicrophonePlaceholderChoose": string,
	"DeviceSelectionDropdownMicrophonePlaceholderEmpty": string,
	"DeviceSelectionDropdownSpeakerPlaceholderChoose": string,
	"DeviceSelectionDropdownSpeakerPlaceholderEmpty": string,
	"DeviceSelectionDropdownSpeakerPlaceholderSystemDefault": string,
	"DeviceSetupCameraPermissionDeniedHint": string,
	"DeviceSetupContinue": string,
	"DeviceSetupDone": string,
	"DeviceSetupHelpLink": string,
	"DeviceSetupMicrophoneHint": string,
	"DeviceSetupMicrophonePermissionDeniedHint": string,
	"DeviceSetupPermissionDeniedModalDescription": string,
	"DeviceSetupPermissionDeniedModalDescriptionDisclaimer": string,
	"DeviceSetupPermissionDeniedModalDescriptionReloadInstruction": string,
	"DeviceSetupPermissionDeniedModalTitle": string,
	"DeviceSetupSpeakerTest": string,
	"DeviceSetupSubtitle": string,
	"DeviceSetupTitle": string,
	"DeviceSetupTitleSetupOnly": string,
	"Disconnected": string,
	"Disconnecting": string,
	"DoYouWantToEndTheCall": string,
	"ErrorCallQualityFeedback": string,
	"Ignore": string,
	"LeavingCall": string,
	"LocalPreviewCameraOff": string,
	"Microphone": string,
	"MicrophoneOffTooltip": string,
	"MicrophoneOnTooltip": string,
	"PhoneCallPopupDescription": string,
	"PhoneCallPopupEndCallButtonText": string,
	"PhoneCallPopupTitleConnected": string,
	"PhoneCallPopupTitleConnecting": string,
	"Reconnect": string,
	"Reconnecting": string,
	"ScreenShareOffTooltip": string,
	"ScreenShareOnTooltip": string,
	"Settings": string,
	"SettingsTooltip": string,
	"Speaker": string,
	"StartPhoneCall": string,
	"StartPhoneCallTooltip": string,
	"Starting": string,
	"VideoLoadingTooltip": string,
	"YouAreTheLastOneHere": string,
	"WaitingForDoctor": string,
	"BackToConsultations": string,
	"Excellent": string,
	"Good": string,
	"Bad": string,
	"Unknown": string,
	"Connection": string,
	"NetworkStatus": string,
	"WaitingForPatient": string,
	"DeviceCameraPermissionDeniedModalDescriptionFirstStep": string,
	"DeviceCameraPermissionDeniedModalDescriptionSecondStep": string,
	"DeviceCameraPermissionDeniedModalDescriptionThirdStep": string,
	"DeviceMicrophonePermissionDeniedModalDescriptionFirstStep": string,
	"DeviceMicrophonePermissionDeniedModalDescriptionSecondStep": string,
	"DeviceMicrophonePermissionDeniedModalDescriptionThirdStep": string,
	"DeviceSetupPermissionDeniedModalDescriptionFirstStep": string,
	"DeviceSetupPermissionDeniedModalDescriptionSecondStep": string,
	"DeviceSetupPermissionDeniedModalDescriptionThirdStep": string,
	"DeviceCameraPermissionDeniedModalDescription": string,
	"DeviceMicrophonePermissionDeniedModalDescription": string,
	"DeviceCameraPermissionDeniedModalDescriptionDisclaimer": string,
	"DeviceMicrophonePermissionDeniedModalDescriptionDisclaimer": string,
	"DeviceCameraPermissionDeniedModalTitle": string,
	"DeviceMicrophonePermissionDeniedModalTitle": string,
	"ChooseBackground": string,
	"AddBackground": string,
	"Blur": string,
	"None": string,
	"NoAnswerInfoHeader": string,
	"NoAnswerInfoText": string,
	"Call": string,
	"SendMail": string,
	"EmailSent": string,
	"ErrorSentEmail": string,
	"TechnicalIssues": string,
	"EndVideo": string,
	"ApproxWaitingTime": (number: number, options?: { minimumFractionDigits?: number, maximumFractionDigits?: number }) => string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "no" || (!process.env.enforcedLocale && getLocale("da") === "no")) {
			return _no[name] ?? name
		}

		return name
	},
}) as Translations

export { R }